import React from 'react';
import PropTypes from 'prop-types';
import { DisableContactDataDialog, ErrorMessageDialog } from './index'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import deLocale from 'date-fns/locale/de';
import 'date-fns';
import { format } from 'date-fns/esm'
import DateFnsUtils from '@date-io/date-fns';
import request from 'superagent'
import moment from 'moment';
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

class AddProgramDialog extends React.Component {
  state = {
    loading: false,
    event: null,
    location: null,
    city: null,
    date_from: null,
    date_to: null,
    price: null,
    participants: null,
    age_min: null,
    age_max: null,
    description: null,
    push_notes: null,
    contact_per_email: null,
    contact_per_tel: null,
    cl_first_name: null,
    cl_last_name: null,
    cl_email: null,
    cl_tel: null,
    drivers_needed: null,
    supervisors_needed: null,
    barbecue: null,

    min_date: new Date(new Date().getFullYear(), 5, 31), // 31.06.
    max_date: new Date(new Date().getFullYear(), 8, 30), // 30.09.

    show_disable_contact_data_dialog: false,
    disable_contact_data_component: "",
    show_error_message: false,
    error_message: ""
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value, ["error_" + name]: false });
  };

  handleSwitchChange = name => event => {
    if (!event.target.checked && (name === "contact_per_email" || name === "contact_per_tel")) {
      this.setState({ show_disable_contact_data_dialog: true, disable_contact_data_component: name });
    } else {
      this.setState({ [name]: event.target.checked, ["error_" + name]: false });
    }
  };

  disableOption = () => {
    this.setState({ show_disable_contact_data_dialog: false, [this.state.disable_contact_data_component]: false, ["error_" + this.state.disable_contact_data_component]: false });
  }

  handleDateStartChange = date => {
    this.setState({ date_from: date, date_to: date, error_date_from: false });
  }

  handleDateEndChange = date => {
    this.setState({ date_to: date, error_date_to: false });
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.addProgram();
      ev.preventDefault();
    }
  }

  onReset = () => {
    this.setState({
      event: null, location: null, city: null, date_from: null, date_to: null, price: null, participants: null, age_min: null, age_max: null,
      description: null, push_notes: null, contact_per_email: null, contact_per_tel: null, cl_first_name: null, cl_last_name: null, cl_email: null, cl_tel: null,
      drivers_needed: null, supervisors_needed: null, barbecue: null,
      error_event: false, error_location: false, error_city: false, error_date_from: false, error_date_to: false, error_price: false, error_participants: false,
      error_age_min: false, error_age_max: false, error_description: false, error_cl_first_name: false, error_cl_last_name: false, error_cl_email: false, error_cl_tel: false
    });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false });
  }

  addProgram = () => {
    this.setState({ loading: true });

    var event = this.state.event === null ? (this.props.program === null ? "" : this.props.program.event) : this.state.event;
    var location = this.state.location === null ? (this.props.program === null ? "" : this.props.program.location) : this.state.location;
    var city = this.state.city === null ? (this.props.program === null ? 0 : this.props.program.city) : this.state.city;
    var date_from = this.state.date_from === null ? (this.props.program === null ? null : this.props.program.date_from) : format(this.state.date_from, 'dd.MM.yyyy');
    var date_to = this.state.date_to === null ? (this.props.program === null ? null : this.props.program.date_to) : format(this.state.date_to, 'dd.MM.yyyy');
    var time_from = this.state.date_from === null ? (this.props.program === null ? null : this.props.program.time_from) : format(this.state.date_from, 'HH:mm');
    var time_to = this.state.date_to === null ? (this.props.program === null ? null : this.props.program.time_to) : format(this.state.date_to, 'HH:mm');
    var price = this.state.price === null ? (this.props.program === null ? 0 : this.props.program.price) : this.state.price;
    var participants = this.state.participants === null ? (this.props.program === null ? 5 : this.props.program.participants) : this.state.participants;
    var age_min = this.state.age_min === null ? (this.props.program === null ? 5 : this.props.program.age_min) : this.state.age_min;
    var age_max = this.state.age_max === null ? (this.props.program === null ? 0 : this.props.program.age_max) : this.state.age_max;
    var description = this.state.description === null ? (this.props.program === null ? "" : this.props.program.description) : this.state.description;
    var push_notes = this.state.push_notes === null ? (this.props.program === null ? "" : this.props.program.push_notes) : this.state.push_notes;
    var contact_per_email = this.state.contact_per_email === null ? (this.props.program !== null ? this.props.program.email.length > 1 : true) : this.state.contact_per_email;
    var contact_per_tel = this.state.contact_per_tel === null ? (this.props.program !== null ? this.props.program.tel.length > 1 : true) : this.state.contact_per_tel;
    var cl_first_name = this.state.cl_first_name === null ? (this.props.program === null ? "" : this.props.program.cl_first_name) : this.state.cl_first_name;
    var cl_last_name = this.state.cl_last_name === null ? (this.props.program === null ? "" : this.props.program.cl_last_name) : this.state.cl_last_name;
    var cl_email = this.state.cl_email === null ? (this.props.program === null ? "" : this.props.program.cl_email) : this.state.cl_email;
    var cl_tel = this.state.cl_tel === null ? (this.props.program === null ? "" : this.props.program.cl_tel) : this.state.cl_tel;
    var drivers_needed = this.state.drivers_needed === null ? (this.props.program === null ? false : this.props.program.drivers_needed) : this.state.drivers_needed;
    var supervisors_needed = this.state.supervisors_needed === null ? (this.props.program === null ? false : this.props.program.supervisors_needed) : this.state.supervisors_needed;
    var barbecue = this.state.barbecue === null ? (this.props.program === null ? false : this.props.program.barbecue) : this.state.barbecue;

    // Überprüfen ob alle Fehler ausgefüllt sind
    if (event.length > 0 && location.length > 0 && city !== 0 && date_from !== null && date_to !== null && price !== "" && participants > 0 && age_min !== "" && age_max !== "" && description.length > 0 && cl_first_name.length > 0 && cl_last_name.length > 0 && this.isValidEmail(cl_email) && cl_tel.length > 0) {
      // Überprüfen ob die E-Mail Addresse und Telefonnummer von den eigenen Benutzerdaten differiert
      if (cl_email !== this.props.userData.email && cl_tel !== this.props.userData.tel) {
        // AgeMax muss größer als AgeMin oder 0 sein
        if (parseInt(age_max) === 0 || parseInt(age_max) >= age_min) {
          let currentComponent = this;
          request.post(Constants.BACKEND_URL)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('accept', 'json')
            .send({ command: this.props.editMode ? "editprogram" : "addprogram", program_id: this.props.program === null ? "" : this.props.program.id, leader_id: this.props.userData.id, event: event, location: location, city: city, date_from: date_from, date_to: date_to, time_from: time_from, time_to: time_to, price: price, participants: participants, age_min: age_min, age_max: age_max, description: description, push_notes: push_notes, show_email: contact_per_email ? 1 : 0, show_tel: contact_per_tel ? 1 : 0, cl_first_name: cl_first_name, cl_last_name: cl_last_name, cl_email: cl_email, cl_tel: cl_tel, drivers_needed: drivers_needed, supervisors_needed: supervisors_needed, barbecue: barbecue })
            .end((err, res) => {
              var result = res.text.trim();
              if (result === "1") {
                //erfolgreich erstellt
                currentComponent.setState({ loading: false });
                currentComponent.props.onClose(true);
              } else {
                currentComponent.setState({ snackbar_open: true, loading: false });
              }
            });
        } else {
          this.setState({ loading: false, error_age_max: true, show_error_message: true, error_message: "Das maximale Alter der Teilnehmer muss höher als das Mindestalter sein oder für unbegrenztes Maximalalter auf 0 gesetzt werden." })
        }
      } else {
        this.setState({ loading: false, error_cl_first_name: true, error_cl_last_name: true, error_cl_email: true, error_cl_tel: true, show_error_message: true, error_message: "Sie können sich nicht selbst als Co-Leiter angeben." })
      }
    } else {
      this.setState({ loading: false, error_event: event.length === 0, error_location: location.length === 0, error_city: city === 0 || city === null, error_date_from: date_from === null, error_date_to: date_to === null, error_price: price.length === 0, error_participants: participants === 0, error_age_min: age_min.length === 0, error_age_max: age_max.length === 0, error_description: description.length === 0, error_cl_first_name: cl_first_name.length === 0, error_cl_last_name: cl_last_name.length === 0, error_cl_email: !this.isValidEmail(cl_email), error_cl_tel: cl_tel.length === 0, show_error_message: true, error_message: "Es sind nicht alle Felder ausgefüllt oder es sind Felder fehlerhaft! Bitte überprüfen Sie alle Felder." });
    }
  }

  onClose = success => {
    this.onReset();
    this.props.onClose(success);
  }

  isValidEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render() {
    const { classes, fullScreen } = this.props;
    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{this.props.program === null ? "Programm erstellen" : "Programm bearbeiten"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          {/* Name */}
          <TextField label="Name des Programms" defaultValue={this.props.program !== null ? this.props.program.event : ""} value={this.state.event} disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('event')} fullWidth style={{ marginTop: -10 }} error={this.state.error_event} required />
          {/* Treffpunkt */}
          <TextField label="Treffpunkt" defaultValue={this.props.program !== null ? this.props.program.location : ""} value={this.state.location} disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('location')} style={{ width: "68%", marginRight: "2%", marginTop: 10 }} error={this.state.error_location} required />
          {/* Ortsteil */}
          <FormControl style={{ width: "30%", marginTop: 10 }} required>
            <InputLabel>Ortsteil</InputLabel>
            <Select value={this.state.city === null ? (this.props.program !== null ? this.props.program.city : 0) : this.state.city} disabled={this.state.loading} onChange={this.handleChange('city')} error={this.state.error_city}>
              <MenuItem value={0}><em>Bitte auswählen</em></MenuItem>
              <MenuItem value={"Schemmerhofen"}>Schemmerhofen</MenuItem>
              <MenuItem value={"Alberweiler"}>Alberweiler</MenuItem>
              <MenuItem value={"Altheim"}>Altheim</MenuItem>
              <MenuItem value={"Aßmannshardt"}>Aßmannshardt</MenuItem>
              <MenuItem value={"Ingerkingen"}>Ingerkingen</MenuItem>
              <MenuItem value={"Schemmerberg"}>Schemmerberg</MenuItem>
            </Select>
          </FormControl>
          {/* Datum & Uhrzeit */}
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
            <DateTimePicker label="Start" format="dd.MM.yyyy HH:mm" ampm={false} disabled={this.state.loading} minDate={this.state.min_date} maxDate={this.state.max_date} cancelLabel="Abbrechen" okLabel="OK" value={this.state.date_from === null ? (this.props.program !== null ? (moment(this.props.program.date_from + " " + this.props.program.time_from, 'DD.MM.YYYY HH:mm').toDate().getFullYear() === new Date().getFullYear() ? moment(this.props.program.date_from + " " + this.props.program.time_from, 'DD.MM.YYYY HH:mm').toDate() : null) : null) : this.state.date_from} onChange={this.handleDateStartChange} error={this.state.error_date_from} style={{ width: "25%", marginTop: 10, marginBottom: 20, marginRight: "2%" }} />
            <DateTimePicker label="Ende" format="dd.MM.yyyy HH:mm" ampm={false} disabled={this.state.loading} minDate={this.state.min_date} maxDate={this.state.max_date} cancelLabel="Abbrechen" okLabel="OK" value={this.state.date_to === null ? (this.props.program !== null ? (moment(this.props.program.date_to + " " + this.props.program.time_to, 'DD.MM.YYYY HH:mm').toDate().getFullYear() === new Date().getFullYear() ? moment(this.props.program.date_to + " " + this.props.program.time_to, 'DD.MM.YYYY HH:mm').toDate() : null) : null) : this.state.date_to} onChange={this.handleDateEndChange} error={this.state.error_date_to} style={{ width: "25%", marginTop: 10, marginRight: "2%" }} />
          </MuiPickersUtilsProvider>
          {/* Kosten */}
          <TextField label="Kosten" defaultValue={this.props.program === null ? 0 : this.props.program.price} value={this.state.price} type="number" disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('price')} inputProps={{ maxLength: 3, min: "0" }} style={{ width: "20%", marginTop: 10, marginRight: "2%" }} InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment> }} error={this.state.error_price} required />
          {/* Teilnehmer */}
          <TextField label="max. Teilnehmer" defaultValue={this.props.program === null ? 5 : this.props.program.participants} value={this.state.participants} type="number" disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('participants')} inputProps={{ maxLength: 3, min: 5 }} style={{ width: "24%", marginTop: 10 }} error={this.state.error_participants} InputProps={{ endAdornment: <InputAdornment position="end">Kinder</InputAdornment> }} required />
          <span>
            {/* Alter min */}
            Altersbegrenzung von<TextField defaultValue={this.props.program === null ? 5 : this.props.program.age_min} value={this.state.age_min} type="number" disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('age_min')} inputProps={{ maxLength: 2, min: 0, max: 99, className: 'digitsOnly' }} style={{ width: 100, marginTop: -7, marginLeft: 10, marginRight: 10 }} InputProps={{ endAdornment: <InputAdornment position="end">Jahren</InputAdornment> }} error={this.state.error_age_min} required />
            {/* Alter max */}
            bis<TextField defaultValue={this.props.program === null ? 0 : this.props.program.age_max} value={this.state.age_max} type="number" disabled={this.state.loading} onKeyPress={this.onEnterPressed} onChange={this.handleChange('age_max')} inputProps={{ maxLength: 2, min: 0, max: 99, className: 'digitsOnly' }} style={{ width: 100, marginTop: -7, marginLeft: 10, marginRight: 50 }} InputProps={{ endAdornment: <InputAdornment position="end">Jahren</InputAdornment> }} error={this.state.error_age_max} required />
          </span>
          <Typography color="secondary">Wenn das maximale Alter unbegrenzt ist, geben Sie bitte eine 0 ein.</Typography>
          {/* Beschreibung */}
          <TextField label="Beschreibung" multiline rows="5" defaultValue={this.props.program !== null ? this.props.program.description.split(" ^ ").join("\n").split("^").join("\n") : ""} value={this.state.description} disabled={this.state.loading} onChange={this.handleChange('description')} fullWidth style={{ marginTop: 5 }} error={this.state.error_description} required />
          {/* Mitzubringen */}
          <TextField label="Mitzubringen (bitte stichwortartig mit Kommata getrennt angeben)" multiline defaultValue={this.props.program !== null ? this.props.program.push_notes.split(" ^ ").join("\n").split("^").join("\n") : ""} value={this.state.push_notes} disabled={this.state.loading} onChange={this.handleChange('push_notes')} fullWidth style={{ marginTop: 10 }} />
          {/* Kontakt */}
          <FormControlLabel control={<Switch checked={this.state.contact_per_email === null ? (this.props.program !== null ? this.props.program.show_email === "1" : true) : this.state.contact_per_email} onChange={this.handleSwitchChange('contact_per_email')} disabled={this.state.loading || this.props.userData.email === ""} />} label="Kontakt per E-Mail erlauben" />
          <FormControlLabel control={<Switch checked={this.state.contact_per_tel === null ? (this.props.program !== null ? this.props.program.show_tel === "1" : true) : this.state.contact_per_tel} onChange={this.handleSwitchChange('contact_per_tel')} />} disabled={this.state.loading || this.props.userData.tel === ""} label="Kontakt per Telefon erlauben" />
          {/* Co-Leiter Vorname */}
          <TextField label="Co-Leiter Vorname" defaultValue={this.props.program === null ? "" : this.props.program.cl_first_name} value={this.state.cl_first_name} onChange={this.handleChange('cl_first_name')} error={this.state.error_cl_first_name} disabled={this.state.loading} style={{ width: "49%", marginRight: "2%" }} required />
          {/* Co-Leiter Nachname */}
          <TextField label="Co-Leiter Nachname" defaultValue={this.props.program === null ? "" : this.props.program.cl_last_name} value={this.state.cl_last_name} onChange={this.handleChange('cl_last_name')} error={this.state.error_cl_last_name} disabled={this.state.loading} style={{ width: "49%" }} required />
          {/* Co-Leiter E-Mail */}
          <TextField label="Co-Leiter E-Mail" defaultValue={this.props.program === null ? "" : this.props.program.cl_email} value={this.state.cl_email} onChange={this.handleChange('cl_email')} error={this.state.error_cl_email} disabled={this.state.loading} style={{ width: "49%", marginRight: "2%", marginTop: 10 }} required />
          {/* Co-Leiter Tel */}
          <TextField label="Co-Leiter Handynummer" defaultValue={this.props.program === null ? "" : this.props.program.cl_tel} value={this.state.cl_tel} onChange={this.handleChange('cl_tel')} error={this.state.error_cl_tel} disabled={this.state.loading} style={{ width: "49%", marginTop: 10, marginBottom: 10 }} required />
          {/* Drivers Needed */}
          <FormControlLabel control={<Switch checked={this.state.drivers_needed === null ? (this.props.program !== null ? this.props.program.drivers_needed === "1" : false) : this.state.drivers_needed} onChange={this.handleSwitchChange('drivers_needed')} disabled={this.state.loading} />} label="Fahrer werden benötigt" />
          {/* Supervisors Needed */}
          <FormControlLabel control={<Switch checked={this.state.supervisors_needed === null ? (this.props.program !== null ? this.props.program.supervisors_needed === "1" : false) : this.state.supervisors_needed} onChange={this.handleSwitchChange('supervisors_needed')} disabled={this.state.loading} />} label="Betreuer werden benötigt" />
          {/* Barbecue */}
          <FormControlLabel control={<Switch checked={this.state.barbecue === null ? (this.props.program !== null ? this.props.program.barbecue === "1" : false) : this.state.barbecue} onChange={this.handleSwitchChange('barbecue')} disabled={this.state.loading} />} label="Die Kinder dürfen Gäste mitbringen" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.onClose(false)} variant="contained" disabled={this.state.loading}>Abbrechen</Button>
          <Button onClick={this.addProgram} variant="contained" disabled={this.state.loading} color="primary" autoFocus>
            {this.props.program !== null ? "Programm speichern" : "Programm erstellen"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Dialoge */}
        <DisableContactDataDialog open={this.state.show_disable_contact_data_dialog} onDisableOption={this.disableOption} onClose={() => this.setState({ show_disable_contact_data_dialog: false })} />
        <ErrorMessageDialog open={this.state.show_error_message} message={this.state.error_message} onClose={() => this.setState({ show_error_message: false })} />
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Erstellen fehlgeschlagen. Bitte versuchen Sie es erneut.
              </span>
            }
            action={[
              <IconButton color="inherit" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

AddProgramDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  userData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  program: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired
};

export default withMobileDialog()(withStyles(styles, { withTheme: true })(AddProgramDialog));
